if (!customElements.get("bundle-atc")) {
  customElements.define(
    "bundle-atc",
    class BundleAtc extends HTMLElement {
      constructor() {
        super();

        this.bundleFormContainer = this.closest(".bundle-payment");
      }

      connectedCallback() {
        if (this.bundleFormContainer) {
          window.addEventListener("scroll", this.scrollBundleAtc.bind(this));
        }
      }

      scrollBundleAtc() {
        const headerBottom = document
          .querySelector("#shopify-section-header")
          .getBoundingClientRect().bottom;
        const containerBottom = this.bundleFormContainer.getBoundingClientRect().bottom;

        var formHeight, stickyHeight;
        if (!this.bundleFormContainer.classList.contains("stickyactive")) {
          formHeight = this.offsetHeight;
        } else {
          stickyHeight = this.offsetHeight;
        }

        if (
          containerBottom <= headerBottom &&
          !this.bundleFormContainer.classList.contains("stickyactive")
        ) {
          this.bundleFormContainer.style.height = `${formHeight + 15}px`;
          this.bundleFormContainer.classList.add("stickyactive");
        } else if (
          containerBottom > headerBottom &&
          this.bundleFormContainer.classList.contains("stickyactive")
        ) {
          this.bundleFormContainer.style.height = "auto";
          this.bundleFormContainer.classList.remove("stickyactive");
        }
      }
    }
  );
}
